import React from 'react';

const AuditFiltersSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6 bg-light-card dark:bg-dark-card rounded-xl border border-light-border dark:border-dark-border">
      {[1, 2].map((i) => (
        <div key={i} className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
          <div className="h-5 w-1/3 bg-light-hover dark:bg-dark-hover rounded mb-2" />
          <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
        </div>
      ))}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 dark:via-white/10 to-transparent skeleton-wave" />
        <div className="h-5 w-1/3 bg-light-hover dark:bg-dark-hover rounded mb-2" />
        <div className="grid grid-cols-2 gap-2">
          <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
          <div className="h-10 bg-light-hover dark:bg-dark-hover rounded-lg" />
        </div>
      </div>
    </div>
  );
};

export default AuditFiltersSkeleton;